export default __webpack_public_path__ + "static/media/404.858d5843.svg";